import client from '../client'

export type SupplyProduct = {
  order?: number
  tag?: string | null
  name?: string | null
  url_image?: string | null
  urlImage?: string | null
  url_product?: string | null
  urlProduct?: string | null
}

export function supplyImagePath(product: SupplyProduct) {
  return product.url_image || product.urlImage || ''
}

export function supplyProductUrl(product: SupplyProduct) {
  return product.url_product || product.urlProduct || ''
}

function productList(body: unknown): SupplyProduct[] {
  if (Array.isArray(body)) return body as SupplyProduct[]
  if (!body || typeof body !== 'object') return []
  const record = body as Record<string, unknown>
  const nested = record.data ?? record.result ?? record.content ?? record.supplies ?? record.list
  return Array.isArray(nested) ? (nested as SupplyProduct[]) : []
}

export async function getSupplies() {
  const response = await client.get<unknown>('/service-api/v1/supplies')
  return productList(response.data)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const ao = typeof a.item.order === 'number' ? a.item.order : Number.MAX_SAFE_INTEGER
      const bo = typeof b.item.order === 'number' ? b.item.order : Number.MAX_SAFE_INTEGER
      return ao - bo || a.index - b.index
    })
    .map(({ item }) => item)
}
